<template>
	<drawer
			:title="titleDrawer"
			@updateClose="onClose"
			@updateSave="onSave"
	>
		<div class="infoUserVacation">
			<div class="infoTitle">Information about the payment period</div>
			<item-info-row
					icon-id="calendar0"
					text="Month:"
					:value="activeItem.month"
			></item-info-row>
			<item-info-row
					icon-id="calendar1"
					text="Period:"
					:value="`${monthDateStart()} - ${monthDateEnd()}`"
			></item-info-row>

		</div>

		<field
				:class-error="getError('amount')"
				margin="0 0 10px 0"
				width="300px"
				label="Amount"
				placeholder="Enter amount"
				:setInputValue="amount"
				@updateInput="onInput($event, 'amount')"
				is-required
				is-number
				type="number"
		></field>

		<field
				:class-error="getError('notes')"
				margin="0 0 10px 0"
				width="300px"
				label="Note"
				placeholder="Enter note"
				:setInputValue="notes"
				@updateInput="onInput($event, 'notes')"
				is-textarea
		></field>

	</drawer>
</template>

<!--info/pay-history-->
<!--'employee_id'   => 'required|integer',-->
<!--'month_pay'     => 'required|date',-->
<!--'amount'        => 'required|integer',-->
<!--'notes'         => 'max:255',-->

<script>
import Drawer from "@/shared/Drawer/Drawer";
import { validationMixin } from "vuelidate";
import { required, maxLength } from "vuelidate/lib/validators";
import ItemInfoRow from "@/shared/ItemInfoRow/ItemInfoRow.vue";

export default {
	name: "SalaryPay",
	mixins: [ validationMixin ],
	components: { ItemInfoRow, Drawer },
	props: {
		activeItem: Object,
		id: Number,
	},
	validations: {
		amount: { required },
		notes: { maxLength: maxLength(255) },
	},

	data() {
		return {
			titleDrawer: 'Salary Pay',
			amount: null,
			notes: null,
		};
	},
	methods: {
		formatDate(date) {
			const month = String(date.getMonth() + 1).padStart(2, '0');
			const day = String(date.getDate()).padStart(2, '0');
			return `${ month }.${ day }`;
		},
		monthDateStart() {
			const myDate = new Date(this.activeItem.date);
			return this.formatDate(myDate);
		},
		monthDateEnd() {
			const myDate = new Date(this.activeItem.date);
			myDate.setDate(myDate.getDate() + 28);
			return this.formatDate(myDate);
		},

		getError(key) {
			return this.$v[key] && this.$v[key].$error;
		},
		onSave() {
			this.$v.$touch();
			if (!this.$v.$error) {
				const employee_id = this.id;
				const month_pay = this.activeItem.date;
				const { amount, notes } = this.$data;
				this.$emit('updateSave', { employee_id, notes, amount: parseFloat(amount), month_pay }, this.activeItem);
			} else {
				this.$store.dispatch('setAlert', { type: "error", message: "Saving error" });
			}
		},
		onClose() {
			this.$emit('updateClose');
		},
		onInput({ value }, key) {
			if (key === 'amount') {
				this[key] = parseFloat(value);
			} else {
				this[key] = value;
			}
		},
	},
	mounted() {
		if (this.activeItem) {
			const { balance } = this.activeItem;
			this.amount = balance ? Math.abs(Number(balance)) : null;
		}
	}
};

</script>

<style scoped lang="scss">
.infoUserVacation {
	display: flex;
	flex-direction: column;
	gap: 8px;
	margin-bottom: 14px;
	.infoTitle {
		font-weight: bold;
		color: #a3a3a3;
	}
}

</style>
